import Vue from 'vue'
import {
  Button,
  Form,
  FormItem,
  Input,
  Message,
  Container,
  Header,
  Main,
  Aside,
  Menu,
  Submenu,
  MenuItem,
  RadioGroup,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  Row,
  Col,
  Select,
  Option,
  Table,
  TableColumn,
  Pagination,
  Dialog,
  Divider,
  Descriptions,
  DescriptionsItem,
  Image,
  DatePicker,
  MessageBox,
  Switch,
  Loading,
  Tooltip,
  Radio,
  TimeSelect,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Checkbox,
  CheckboxGroup,
  InputNumber,
  Popover,
  Link,
  Upload,
  ColorPicker
  // ScrollBar
} from 'element-ui'

Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Aside)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(RadioGroup)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Select)
Vue.use(Option)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Divider)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Image)
Vue.use(DatePicker)
Vue.use(Switch)
Vue.use(Loading)
Vue.use(Tooltip)
Vue.use(Radio)
Vue.use(TimeSelect)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(InputNumber)
Vue.use(Popover)
Vue.use(Link)
Vue.use(Upload)
Vue.use(ColorPicker)

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox
